import {IconButton} from '@mui/material';
import HeaderMenu from './HeaderMenu';
import CloseIcon from '@mui/icons-material/Close';
import UserInfo from './UserInfo';
import SettingsLink from './SettingsLink';
import LogoutOption from './LogoutOption';
import {useTranslation} from 'react-i18next';

type Props = {
  isMenuOpen: boolean;
  handleMenuOpenClose: (state: boolean) => void;
};

function MobileSidebar({isMenuOpen, handleMenuOpenClose}: Props) {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';

  return (
    <div
      className={`
      fixed top-0 bottom-0 w-[270px] z-50 overflow-hidden transform transition-transform duration-300 ease-in-out  lg:hidden
      ${isMenuOpen ? 'opacity-100' : 'opacity-0'}
      ${isHebrew ? 'left-0' : 'right-0'}
      ${
        isMenuOpen
          ? 'translate-x-0'
          : isHebrew
          ? '-translate-x-full'
          : 'translate-x-full'
      }
    `}>
      <div className="w-full h-full p-2">
        <div className="w-full h-full rounded-[16px] border-[1px] border-gray bg-darkBlue flex flex-col justify-between gap-3 p-3">
          <div className="flex justify-end">
            <IconButton onClick={() => handleMenuOpenClose(false)}>
              <CloseIcon sx={{color: '#BABCBE', fontSize: 35}} />
            </IconButton>
          </div>

          {/* Sidebar Menu */}
          <HeaderMenu handleMenuOpenClose={handleMenuOpenClose} />

          <div className="flex flex-col gap-3 mb-3">
            <SettingsLink handleMenuOpenClose={handleMenuOpenClose} />
            <LogoutOption handleMenuOpenClose={handleMenuOpenClose} />
          </div>

          <UserInfo />
        </div>
      </div>
    </div>
  );
}

export default MobileSidebar;
